// SkipHydration.jsx

import React from 'react';
import PropTypes from 'prop-types';

import { component as componentDebug } from '../resource/debug.js';
import { reduxStoreInitializePromise } from '../resource/reduxStoreInitializePromise.js';

const log = componentDebug.extend('log:SkipHydration');

export default class SkipHydration extends React.PureComponent {
  state = {
    shouldRender: false,
    reduxInitCompleted: false,
  };

  timeoutHandle = null;

  componentDidMount() {
    const { filename } = this.props;
    this.timeoutHandle = setTimeout(() => {
      log('setTimeout execute', filename, this.timeoutHandle);
      this.setState({
        shouldRender: true,
      });
    });

    reduxStoreInitializePromise.then(() => {
      this.setState({ reduxInitCompleted: true });
    });

    log('componentDidMount', filename, this.timeoutHandle);
  }

  componentWillUnmount() {
    const { filename } = this.props;
    log('componentWillUnmount', filename, this.timeoutHandle);
    clearTimeout(this.timeoutHandle);
  }

  render() {
    const { filename } = this.props;

    log('render', filename, this.state, this.props);

    if (!this.state.shouldRender || !this.state.reduxInitCompleted) return null;
    return this.props.render();
  }
}

SkipHydration.propTypes = {
  render: PropTypes.func.isRequired,
  filename: PropTypes.string,
};
